/**
 * @generated SignedSource<<3e6e3137097dff416eedf53ac860dcbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRecentSales_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer">;
  readonly " $fragmentType": "SharedRecentSales_viewer";
};
export type SharedRecentSales_viewer$key = {
  readonly " $data"?: SharedRecentSales_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRecentSales_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRecentSales_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "934876d1d1da1979e6eb92f7659ea902";

export default node;
